import React from "react";

const RemoveFavourites = () => {
    return (
        <>
            <span>Remove Favourite ❌</span> 
        </>
    )
}

export default RemoveFavourites